export const DOWNLOAD_SHARED_WORKOUT_START = 'DOWNLOAD_SHARED_WORKOUT_START';
export const DOWNLOAD_SHARED_WORKOUT_FULFILLED = 'DOWNLOAD_SHARED_WORKOUT_FULFILLED';
export const DOWNLOAD_SHARED_WORKOUT_REJECTED = 'DOWNLOAD_SHARED_WORKOUT_REJECTED';

export const DOWNLOAD_SHARED_WORKOUT_INITIALIZE_START = 'DOWNLOAD_SHARED_WORKOUT_INITIALIZE_START';
export const DOWNLOAD_SHARED_WORKOUT_INITIALIZE_FULFILLED = 'DOWNLOAD_SHARED_WORKOUT_INITIALIZE_FULFILLED';
export const DOWNLOAD_SHARED_WORKOUT_INITIALIZE_REJECTED = 'DOWNLOAD_SHARED_WORKOUT_INITIALIZE_REJECTED';

export const FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START = 'FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_START';
export const FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED = 'FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_FULFILLED';
export const FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED = 'FETCH_SHARED_WORKOUT_PROGRAM_DETAILS_REJECTED';

export const FETCH_SHARED_WORKOUT_PREVIEW_START = 'FETCH_SHARED_WORKOUT_PREVIEW_START';
export const FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED = 'FETCH_SHARED_WORKOUT_PREVIEW_FULFILLED';
export const FETCH_SHARED_WORKOUT_PREVIEW_REJECTED = 'FETCH_SHARED_WORKOUT_PREVIEW_REJECTED';

export const SET_ACTIVE_SHARED_WORKOUT_MODAL = 'SET_ACTIVE_SHARED_WORKOUT_MODAL';

export const SET_IS_DOWNLOAD_BUTTON_CLICKED = 'SET_IS_DOWNLOAD_BUTTON_CLICKED';
